import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Notification } from 'rsuite';
import { Container, Content, Footer } from 'rsuite';
import { Button, Card, Form, Input } from 'semantic-ui-react'

import { api } from '../../services/api';

import './styles.css';

export default function Login () {
    const history = useHistory();
    const [loginStates, setLoginStates] = useState({
        isLoading: false,
        username: "",
        password: ""
    });

    function open() {
        Notification.error({
          title: 'Falha ao efetuar login',
          duration: 5000,
          description: (
            <div>
              <p>Verifique a conexão com a internet.</p>
            </div>
          )
        });
    }

    const setUsername = (username) => {
        setLoginStates({
            ...loginStates,
            username: username
        });
    }

    const setPassword = (password) => {
        setLoginStates({
            ...loginStates,
            password: password
        });
    }

    const setIsLoading = (isLoading) => {
        setLoginStates({
            ...loginStates,
            isLoading: isLoading
        });
    }

    async function handleLogin(e) {
        // prevent a browser reload/refresh
        e.preventDefault();
        setIsLoading(true);

        try {
            await api.login(loginStates['username'], loginStates['password']);
            setIsLoading(false);
            history.push('/map');
        } catch(err) {
            console.error("Falha na autenticação: ", err);
            open();
            setIsLoading(false);
        }
    }

    return (
        <div className="show-fake-browser sidebar-page">
            <Container>
                <Content style={{ backgroundColor: '#FAFAFA'}}>
                    <div className="logon-container">
                    <Card style={{width: '400px'}}>
                        <Card.Content header='Pro Atend' />
                        <Card.Content >
                            <Form
                                loading={loginStates['isLoading']}
                                size="large"
                                style={{padding: '20px'}}
                                autoComplete="off"
                                >
                                <Form.Group widths='equal'>
                                    <Form.Field
                                        icon='mail' iconPosition='left'
                                        id='form-input-control-email'
                                        control={Input}
                                        label='Email'
                                        placeholder='exemplo@exemplo.com'
                                        value={loginStates['username']}
                                        onChange={e => setUsername(e.target.value)}

                                    />
                                </Form.Group>
                                <Form.Field
                                    icon='lock' iconPosition='left'
                                    id='form-input-control-first-name'
                                    control={Input}
                                    label='Senha'
                                    placeholder='senha'
                                    type='password'
                                    value={loginStates['password']}
                                    onChange={e => setPassword(e.target.value)}
                                />
                                <Form.Field
                                    fluid
                                    color='blue'
                                    id='form-button-control-public'
                                    control={Button}
                                    content='Entrar'
                                    onClick={handleLogin}
                                />
                            </Form>
                        </Card.Content>
                        <Card.Content extra>

                        </Card.Content>
                    </Card>
                </div>
                    </Content>
                    <Footer></Footer>
            </Container>
        </div>
    );
}
